import * as React from "react";
import { singleton } from "logic/singleton";
const LicenseCheckContext = React.createContext(void 0);
export default singleton("contexts.LicenseCheckContext", () => LicenseCheckContext);
